import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=0b029076&"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b029076')) {
      api.createRecord('0b029076', component.options)
    } else {
      api.reload('0b029076', component.options)
    }
    module.hot.accept("./ChangePasswordForm.vue?vue&type=template&id=0b029076&", function () {
      api.rerender('0b029076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/ChangePasswordForm.vue"
export default component.exports